import Hero from "@/components/HeroSection/Hero";
import { MarqueeDemo } from "@/components/Testimonials/Testimonials";
import NumberCounter from "@/components/NumberCounter/NumberCounter";
import React from "react";
import TopProducts from "@/components/TopProducts/TopProducts";
import Ripple from "@/components/ui/ripple";
import FeatureSection from "@/components/FeatureSection.jsx/FeatureSection";
import NewTopProducts from "@/components/TopProducts/NewTopProducts";
import TestimonialCarousel from "@/components/Testimonials/NewTestimonials";
import ResumeMakerBanner from "@/components/Banner/ResumeMakerBanner";
import StudentsPlacementSection from "@/components/Caraousel/Caraousel";
import WhatsAppButton from "@/components/Whatsapp/WhatsAppButton";
import JobOpeningsCarousel from "@/components/JobCaraousel/JobOpeningsCaraousel";
import ReviewScroller from "@/components/Testimonials/HomePageTestimonial";

import { Link } from "react-router-dom";

import WebinarBanners from "@/components/Banner/WebinarBanners";
import ImageWebinar from "@/components/Banner/ImageWebinar";
// import WebinarPreview from "../WebinarPage/WebinarPreview";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      {/* <ResumeMakerBanner /> */}

      {/* <WebinarBanners /> */}

      {/* <JobOpeningsCarousel /> */}

      <Hero />
      {/* <ImageWebinar /> */}
      {/* <WebinarPreview /> */}
      <div className="relative w-full -mt-[-0rem] overflow-x-hidden overflow-y-hidden">
        {/* <Ripple className = "top-20 md:block hidden " mainCircleSize={600}
        mainCircleOpacity={0.3}
        numCircles= {10}/>

        <Ripple className = " md:hidden block " mainCircleSize={100}
        mainCircleOpacity={0.8}
        numCircles= {10}/> */}

        <NumberCounter />
        <StudentsPlacementSection />
        <NewTopProducts />
      </div>
      {/* <MarqueeDemo /> */}
      <ReviewScroller />
      {/* <TestimonialCarousel/> */}
      <FeatureSection />

      <WhatsAppButton phoneNumber="9560699151" />
    </div>
  );
};

export default HomePage;
